import React from "react";

const DeletedList = ({ deletedQuestions, restoreQuestion }) => {
  return (
    <div className="mt-6 p-6 bg-gray-50 border border-gray-300 rounded-lg shadow-lg">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Deleted Questions</h3>
      {deletedQuestions.length === 0 ? (
        <p className="text-gray-600">No deleted questions available.</p>
      ) : (
        <table className="min-w-full bg-white border border-gray-300 rounded-lg">
          <thead>
            <tr className="bg-gray-200 text-gray-800">
              <th className="p-3 border-b border-gray-300 text-left">ID</th>
              <th className="p-3 border-b border-gray-300 text-left">Q Title</th>
              <th className="p-3 border-b border-gray-300 text-left">Title</th>
              <th className="p-3 border-b border-gray-300 text-left">Deleted At</th>
              <th className="p-3 border-b border-gray-300 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {deletedQuestions.map((question) => (
              <tr key={question.id} className="hover:bg-gray-100">
                <td className="p-3 border-b border-gray-300">{question.id}</td>
                <td className="p-3 border-b border-gray-300">{question.q_title}</td>
                <td className="p-3 border-b border-gray-300">{question.title}</td>
                <td className="p-3 border-b border-gray-300">{new Date(question.deletedAt).toLocaleString()}</td>
                <td className="p-3 border-b border-gray-300">
                  <button
                    onClick={() => restoreQuestion(question.id)} // Restore question function
                    className="px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none"
                  >
                    Restore
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DeletedList;
